import axiosMultipartInstance from "~/shared/api/axios-multipart-instance";

export const updateFloorPlan = async (params: {
  branchUid: string;
  versionId?: number;
  floorPlanId: number;
  name?: string;
  image?: File;
  iconSize?: number;
  labelSize?: number;
}) => {
  const formData = new FormData();
  if (params.name) {
    formData.append("name", params.name);
  }
  if (params.image) {
    formData.append("img", params.image);
  }
  if (params.versionId != null) {
    formData.append("version", params.versionId.toString());
  }
  if (params.iconSize != null) {
    formData.append("icon_size", params.iconSize.toString());
  }
  if (params.labelSize != null) {
    formData.append("label_size", params.labelSize.toString());
  }
  const { data } = await axiosMultipartInstance.patch(
    `branches/${params.branchUid}/floor-plans/${params.floorPlanId}/`,
    formData,
  );
  return data;
};
